module.exports = __webpack_public_path__ + "img/img_realtime_bg2.d23aa517.svg";